<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "MemberActionLayout"
    }
</script>

<style scoped>

</style>
